const dataString = ['null', 'undefined']
/**
 * This function sorting array according field 
 @param {Array} data - Array original to sort 
 @param {String} field - organizing field - Default 'code'
 @param {String} order - acs o desc
 @param {String} type - organizing by string, date or number
*/
const sortData = (data = [], field = 'code', order = 'asc',  type = 'string') => {
  let list = data
  return list.sort((a, b) => {
    if (String(a[field]) && String(b[field]) && !dataString.includes(String(a[field])) && !dataString.includes(String(b[field]))) {
      if (type === 'date') {
        if(new Date(a[field]) < new Date(b[field])) { return order === 'acs' ? -1 : 1 }
        if(new Date(a[field]) > new Date(b[field])) { return order === 'acs' ? 1 : -1 }
      } else if (type === 'number') {
        if(parseFloat(a[field]) < parseFloat(b[field])) { return order === 'acs' ? -1 : 1 }
        if(parseFloat(a[field]) > parseFloat(b[field])) { return order === 'acs' ? 1 : -1 }
      } else {
        if(String(a[field]).toLowerCase() < String(b[field]).toLowerCase()) { return order === 'acs' ? -1 : 1 }
        if(String(a[field]).toLowerCase() > String(b[field]).toLowerCase()) { return order === 'acs' ? 1 : -1 }
      }
    }
    return 0
  })
} 


/**
 * This function sorting array according field 
 @param {Array} data - Array original to sort 
 @param {String} field1 - organizing field firth column - Default 'code'
 @param {Boolean} number1 - organizing by number firth column 
 @param {String} field2 - organizing field second column - Default 'code'
 @param {Boolean} number2 - organizing by number second column
*/
const sortDataByTwoColumns = (data, field1 = 'code', field2 = 'code', number1, number2) => {
    let list = [...data]
    return list.sort((a, b) => {
    var aSize = number1 ? parseFloat(a[field1]) : a[field1];
    var bSize = number1 ? parseFloat(b[field1]) : b[field1];
    var aLow = number2 ? parseFloat(a[field2]) : a[field2];
    var bLow = number2 ? parseFloat(b[field2]) : b[field2];

    if (aSize === bSize) {
      return (aLow < bLow) ? -1 : (aLow > bLow) ? 1 : 0;
    } else {
      return (aSize < bSize) ? -1 : 1;
    }
  })
} 

/**
 * This function remove to array element duplicate according prop
 @param {Array} originalArray - Array original to remove duplicates 
 @param {String} prop - field uniqued - Default '_id'
*/
const removeDuplicates = (originalArray, prop = '_id') => {
    let newArray = [];
    let lookupObject  = {};
  
    for(var i in originalArray) {
      lookupObject[originalArray[i][prop]] = originalArray[i]
    }
  
    for(i in lookupObject) {
      newArray.push(lookupObject[i])
    }
  
    return newArray
}

/**
 * This function reverses the order of the elements of an array. The first item becomes the last and the last becomes the first
 @param {Array} array - Array original 
*/
const reverseData = (array) => {
  var reverse = []
  var length = array.length

  for (var i = length-1; i>=0; i--) {
    reverse.push(array[i])
  }
  return reverse
}

/**
 * This function group array by type
 @param {Array} array - Array original 
 @param {String} type - type
*/
const groupArray = (array, type) => {
  let data = array
  let groups = []

  if (type) {
    groups = array.map((item) => item[type])
    groups = [ ...new Set(groups) ]
  }
  if (groups.length > 0) {
    data = []
    groups.forEach((group) => {
      data.push({
        group,
        items: array.filter((el) => el[type] === group)
      })
    })
  }

  return data
}


export {
    sortData, 
    sortDataByTwoColumns,
    removeDuplicates,
    reverseData,
    groupArray
}